import '../src/app/i18n/i18n';
import React, { useEffect, useState } from 'react';
import { API_BASE_URL } from './api';
import { BrowserRouter as Router, Routes, Route, useLocation, useNavigate, Navigate } from 'react-router-dom';
import Login from '../src/app/modules/layout/Login/Login';
import './App.css';
import Swal from 'sweetalert2';
import AuthCards from "../src/app/modules/layout/Login/AuthCards";
import { useDispatch, useSelector } from "react-redux";
import { getUserRequest } from "./app/redux/actions/userActions";
import JobManagement from "./app/modules/jobs/Jobmanagement";
import JobDescriptionGenerator from "./app/modules/jobs/JobDescriptionGenerator";
import Sidebar from "./app/modules/layout/Sidebar/Sidebar";
import UpperBar from "./app/modules/layout/UpperBar/UpperBar";
import CompanyManagement from "./app/modules/compagnies/CompanyManagement";
import SidebarMenuManagement from "./app/modules/MenusManagment/SidebarMenuManagement";
import UserMassImport from "./app/modules/Users/UserMassImport";
import SeuilPassageManagement from "./app/modules/jobs/SeuilPassage/SeuilPassageManagement";
import Chatbot from "./app/modules/adminrh/Chatbot/Chatbot";

import { FormationRoutes } from "./routes/formationRoutes";
import { RecrutementRoutes } from "./routes/recrutementRoutes";
import { AdminGrhRoutes } from "./routes/adminGrhRoutes";
import GestionEmails from "./app/modules/layout/Emails/GestionEmails";
import EntiteManagement from "./app/modules/Users/entites/EntiteManagement";
import EmailLogs from "./app/modules/layout/Emails/EmailsLogs";
import LogsPage from "./app/modules/layout/Logs/LogsPage";
import Modulemanagement from "./app/modules/layout/Modules/Modulemanagement";
import Rolemanagement from "./app/modules/layout/Roles/Rolemanagement";
import ParamInfosUsers from "./app/modules/Profile/ParamInfosUsers";
import { SkillsRoutes } from "./routes/skillsRoutes";
import { kmsRoutes } from "./routes/kmsRoutes";
import { OnboardingRoutes } from "./routes/onboardingRoutes";
import UserRoleAssignment from "./app/modules/layout/Roles/UserRoleAssignment";
import ValidationModifProfil from "./app/modules/Profile/ValidationModifProfil";
import SessionManagement from "./app/modules/adminrh/Sessions/SessionManagement";
import NotificationSettings from "./app/modules/adminrh/parametres/parametresJS/NotificationSettings";
import TaskSettings from "./app/modules/adminrh/parametres/parametresJS/TaskSettings";
import KpiManagement from "./app/modules/adminrh/KpiManagement";
import {performanceRoutes} from "./routes/performanceRoutes";

const normalizeAppPath = (path) => {
    if (!path || typeof path !== "string") return "";
    const trimmed = path.trim();
    if (!trimmed) return "";
    return trimmed.startsWith("/") ? trimmed : `/${trimmed}`;
};

const AppLoader = ({ message = "Chargement de votre session..." }) => (
    <div style={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '24px',
        background: '#f8fafc'
    }}>
        <div style={{
            minWidth: '280px',
            maxWidth: '420px',
            padding: '28px',
            borderRadius: '18px',
            background: '#ffffff',
            border: '1px solid #e5e7eb',
            boxShadow: '0 12px 30px rgba(15,23,42,0.08)',
            textAlign: 'center',
            color: '#334155'
        }}>
            <div style={{
                width: '34px',
                height: '34px',
                margin: '0 auto 16px',
                borderRadius: '50%',
                border: '3px solid #e5e7eb',
                borderTopColor: '#204385',
                animation: 'kmsSpin 0.8s linear infinite'
            }} />
            <p style={{ margin: 0 }}>{message}</p>
        </div>
    </div>
);

const AuthenticatedApp = () => {
    const location = useLocation();
    const navigate = useNavigate();

    const user = useSelector((state) => state?.auth?.user || state?.user?.currentUser);
    const currentRole = useSelector((state) => state.role?.selectedRole);

    const [isSidebarCollapsed, setIsSidebarCollapsed] = useState(() => {
        const saved = localStorage.getItem("sidebarCollapsed");
        return saved === "true";
    });

    const [isResponsive, setIsResponsive] = useState(window.innerWidth <= 1200);

    const [isRTL, setIsRTL] = useState(document.documentElement.getAttribute('dir') === 'rtl');

    useEffect(() => {
        const handleResize = () => {
            setIsResponsive(window.innerWidth <= 1200);
        };
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    useEffect(() => {
        const checkRTL = () => {
            const dir = document.documentElement.getAttribute('dir');
            const newIsRTL = dir === 'rtl';
            if (newIsRTL !== isRTL) {
                setIsRTL(newIsRTL);
            }
        };

        checkRTL();
        const interval = setInterval(checkRTL, 100);
        const observer = new MutationObserver(checkRTL);
        observer.observe(document.documentElement, {
            attributes: true,
            attributeFilter: ['dir']
        });

        return () => {
            clearInterval(interval);
            observer.disconnect();
        };
    }, [isRTL]);

    useEffect(() => {
        const handleStorageChange = () => {
            const saved = localStorage.getItem("sidebarCollapsed");
            setIsSidebarCollapsed(saved === "true");
        };

        window.addEventListener('storage', handleStorageChange);

        const interval = setInterval(() => {
            const saved = localStorage.getItem("sidebarCollapsed");
            const newValue = saved === "true";
            if (newValue !== isSidebarCollapsed) {
                setIsSidebarCollapsed(newValue);
            }
        }, 100);

        return () => {
            window.removeEventListener('storage', handleStorageChange);
            clearInterval(interval);
        };
    }, [isSidebarCollapsed]);

    const pagesWithoutSidebar = ['/cards', '/collaborateur/onboarding'];
    const isWithoutSidebar = pagesWithoutSidebar.includes(location.pathname);

    const pagesWithoutUpperBar = ['/cards', '/collaborateur/onboarding'];
    const isWithoutUpperBar = pagesWithoutUpperBar.includes(location.pathname);

    const getHomeByRole = (roleObj) => {
        if (!roleObj) return '/';

        const onboardingRoleName = `${roleObj.name || ''} ${roleObj.code || ''}`.toUpperCase();
        const compactOnboardingRoleName = onboardingRoleName.replace(/\s+/g, '');
        if (Number(roleObj.id) === 54 || compactOnboardingRoleName.includes('RESPONSABLEONBOARDING')) return '/recrutement/onboarding/configuration';
        if (Number(roleObj.id) === 53) return '/collaborateur/onboarding';

        const routePath = normalizeAppPath(roleObj.routePath || roleObj.modulePath || roleObj.module_path);
        if (routePath) return routePath;

        const roleName =
            typeof roleObj === 'string'
                ? roleObj
                : roleObj.name || roleObj.code || '';

        const r = roleName.toUpperCase();

        if (r.includes('MANAGER')) {
            return '/manager/dashboard';
        }

        if (r.includes('COLLAB') || r.includes('EMPLOYEE')) {
            return '/collaborateur/dashboard';
        }

        return '/dashboard';
    };



    useEffect(() => {
        if (!user?.id) return;
        if (!currentRole) return;

        const target = getHomeByRole(currentRole);
        const shouldRedirectToHome = location.pathname === '/' || location.pathname === '/cards';

        if (isWithoutSidebar) return;
        if (!shouldRedirectToHome || location.pathname === target) return;

        navigate(target, { replace: true });
    }, [currentRole, isWithoutSidebar, location.pathname, navigate, user?.id]);

    const getRoleStr = (r) => {
        if (!r) return '';
        if (typeof r === 'string') return r;
        return r.name || r.code || '';
    };
    const roleStr = getRoleStr(currentRole).toUpperCase();
    const isNR = Number(currentRole?.id) === 53;

    const sidebarWidth = (isNR || isWithoutSidebar) ? 0 : (isResponsive ? 80 : (isSidebarCollapsed ? 80 : 260));

    return (
        <>
            {!isWithoutUpperBar && user?.id && (
                <UpperBar />
            )}
            {!isWithoutSidebar && user?.id && !isNR && (
                <Sidebar user={user} />
            )}

            <div style={{
                marginLeft: isWithoutSidebar ? 0 : (isRTL ? 0 : `${sidebarWidth}px`),
                marginRight: isWithoutSidebar ? 0 : (isRTL ? `${sidebarWidth}px` : 0),
                width: isWithoutSidebar ? '100%' : `calc(100% - ${sidebarWidth}px)`,
                minHeight: '100vh',
                transition: 'margin-left 0.4s cubic-bezier(0.4, 0, 0.2, 1), margin-right 0.4s cubic-bezier(0.4, 0, 0.2, 1), width 0.4s cubic-bezier(0.4, 0, 0.2, 1)',
                paddingTop: isWithoutUpperBar ? 0 : '73px',
            }}>
                <Routes>
                    <Route path="/cards" element={<AuthCards />} />
                    <Route path="/postes" element={<JobManagement />} />
                    <Route path="/postes/fiches" element={<JobDescriptionGenerator />} />
                    <Route path="/postes/seuils" element={<SeuilPassageManagement />} />
                    <Route path="/emails" element={<GestionEmails />} />
                    <Route path="/roles" element={<Rolemanagement />} />
                    <Route path="/entreprises" element={<CompanyManagement />} />
                    <Route path="/utilisateurs" element={<UserMassImport />} />
                     <Route path="/permissions" element={<SidebarMenuManagement />} />
                    <Route path="/modules" element={<Modulemanagement />} />
                    <Route path="/journal" element={<LogsPage />} />
                    <Route path="/company/info" element={<ParamInfosUsers />} />
                    <Route path="/entities" element={<EntiteManagement />} />
                    <Route path="/affectation-roles" element={<UserRoleAssignment />} />
                    <Route path="/gestion-kpis" element={<KpiManagement />} />

                    <Route path="/traitement-users" element={<ValidationModifProfil />} />
                    <Route path="/admin/sessions" element={<SessionManagement />} />
                    <Route path="/parametres/notifications" element={<NotificationSettings />} />
                    <Route path="/parametres/taches" element={<TaskSettings />} />
                    {FormationRoutes.map(route => (
                        <Route key={route.path} path={route.path} element={route.element} />
                    ))}
                    {performanceRoutes.map(route => (
                        <Route key={route.path} path={route.path} element={route.element} />
                    ))}
                    {RecrutementRoutes.map(route => (
                        <Route key={route.path} path={route.path} element={route.element} />
                    ))}
                    {AdminGrhRoutes.map(route => (
                        <Route key={route.path} path={route.path} element={route.element} />
                    ))}
                    {SkillsRoutes.map(route => (
                        <Route key={route.path} path={route.path} element={route.element} />
                    ))}
                    {kmsRoutes.map(route => (
                        <Route key={route.path} path={route.path} element={route.element} />
                    ))}
                    {OnboardingRoutes.map(route => (
                        <Route key={route.path} path={route.path} element={route.element} />
                    ))}
                </Routes>

                {/* Chatbot masqué sur la page /cards */}
                {/*{!isWithoutSidebar && <Chatbot />}*/}
            </div>
        </>
    );
};

const App = () => {
    const dispatch = useDispatch();

    const isLoggedState = useSelector((state) => state.auth.isLogged);
    const currentUser = useSelector((state) => state.user.currentUser);
    const loadingUser = useSelector((state) => state.user.loading);

    const uid = sessionStorage.getItem("uid");
    const token = sessionStorage.getItem("token") || localStorage.getItem("token");

    const isLogged = Boolean(isLoggedState || (token && uid));
    const isHydratingSession = Boolean(token && uid && !currentUser && loadingUser);

    useEffect(() => {
        if (uid && token && !currentUser) {
            dispatch(getUserRequest(uid));
        }
    }, [uid, token, currentUser, dispatch]);

    useEffect(() => {
        const handleTabClose = () => {
            if (token) {
                // Utilisation de fetch avec keepalive pour la fermeture d'onglet
                fetch(`${API_BASE_URL}/api/auth/logout`, {
                    method: 'POST',
                    headers: { 'Authorization': `Bearer ${token}` },
                    keepalive: true
                });
            }
        };
        window.addEventListener('beforeunload', handleTabClose);
        return () => window.removeEventListener('beforeunload', handleTabClose);
    }, [token]);

    // --- IDLE TIMEOUT WITH SWEETALERT COUNTDOWN ---
    useEffect(() => {
        if (!isLogged || !token) return;

        let idleTimer;
        let countdownInterval;
        const IDLE_LIMIT = 15 * 60 * 1000; // 15 minutes total
        const WARNING_TIME = 60 * 1000;    // 1 minute de compte à rebours final

        const performLogout = () => {
            if (Swal.isVisible()) Swal.close();
            fetch(`${API_BASE_URL}/api/auth/logout`, {
                method: 'POST',
                headers: { 'Authorization': `Bearer ${token}` }
            }).finally(() => {
                sessionStorage.clear();
                window.location.href = '/';
            });
        };

        const showWarning = () => {
            let timeLeft = 60;

            Swal.fire({
                title: 'Session sur le point d\'expirer',
                html: 'Vous allez être déconnecté dans <b>60</b> secondes par mesure de sécurité.',
                icon: 'warning',
                showCancelButton: true,
                confirmButtonText: 'Rester connecté',
                cancelButtonText: 'Se déconnecter',
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                timer: WARNING_TIME,
                timerProgressBar: true,
                allowOutsideClick: false,
                didOpen: () => {
                    countdownInterval = setInterval(() => {
                        timeLeft--;
                        const content = Swal.getHtmlContainer();
                        if (content) {
                            const b = content.querySelector('b');
                            if (b) b.textContent = timeLeft;
                        }
                    }, 1000);
                },
                willClose: () => {
                    clearInterval(countdownInterval);
                }
            }).then((result) => {
                if (result.isConfirmed) {
                    resetTimer(); // L'utilisateur veut rester
                } else if (result.dismiss === Swal.DismissReason.timer || result.isDismissed) {
                    performLogout(); // Temps écoulé ou clic annuler
                }
            });
        };

        const resetTimer = () => {
            if (idleTimer) clearTimeout(idleTimer);
            if (Swal.isVisible()) return; // On ne reset pas si l'alerte est déjà là (sauf via le bouton)

            idleTimer = setTimeout(showWarning, IDLE_LIMIT - WARNING_TIME);
        };

        const activityEvents = ['mousedown', 'mousemove', 'keydown', 'scroll', 'touchstart'];
        activityEvents.forEach(e => window.addEventListener(e, resetTimer));

        resetTimer();

        return () => {
            activityEvents.forEach(e => window.removeEventListener(e, resetTimer));
            if (idleTimer) clearTimeout(idleTimer);
            if (countdownInterval) clearInterval(countdownInterval);
        };
    }, [isLogged, token]);

    return (
        <Router>
            <Routes>
                {!isLogged && (
                    <>
                        <Route path="/" element={<Login />} />
                        <Route path="*" element={<Navigate to="/" replace />} />

                    </>
                )}

                {isLogged && (
                    <>
                        <Route path="/*" element={isHydratingSession ? <AppLoader /> : <AuthenticatedApp />} />
                        <Route path="/" element={<Navigate to="/cards" replace />} />

                    </>
                )}
            </Routes>
        </Router>
    );
};

export default App;
